import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { DataProvider } from "./contexts/DataContext";

// Public Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import MapSection from "./components/MapSection";
import Excursions from "./components/Excursions";
import Vehicles from "./components/Vehicles";
import Testimonials from "./components/Testimonials";
import BookingForm from "./components/BookingForm";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

// Admin Pages
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminReservations from "./pages/AdminReservations";
import AdminZones from "./pages/AdminZones";
import AdminHotels from "./pages/AdminHotels";
import AdminVehicles from "./pages/AdminVehicles";
import AdminExcursions from "./pages/AdminExcursions";
import AdminTestimonials from "./pages/AdminTestimonials";
import AdminFaqs from "./pages/AdminFaqs";
import AdminSettings from "./pages/AdminSettings";
import AdminRoutePrices from "./pages/AdminRoutePrices";

// Home Page
function HomePage() {
  return (
    <div className="min-h-screen bg-[#0A192F]">
      <Header />
      <main>
        <Hero />
        <Services />
        <MapSection />
        <Excursions />
        <Vehicles />
        <Testimonials />
        <BookingForm />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <DataProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="reservations" element={<AdminReservations />} />
              <Route path="zones" element={<AdminZones />} />
              <Route path="hotels" element={<AdminHotels />} />
              <Route path="route-prices" element={<AdminRoutePrices />} />
              <Route path="vehicles" element={<AdminVehicles />} />
              <Route path="excursions" element={<AdminExcursions />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="faqs" element={<AdminFaqs />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
          
          <Toaster 
            position="top-right"
            toastOptions={{
              style: {
                background: '#1E293B',
                color: '#F8FAFC',
                border: '1px solid rgba(255,255,255,0.1)',
              },
            }}
          />
        </BrowserRouter>
        </DataProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
